import { Library } from '@googlemaps/js-api-loader/dist/index';
import { useLoadScript } from '@react-google-maps/api';
import { selectUserProfile } from 'app/containers/AuthProvider/selectors';
import { FC, memo, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const GOOGLE_MAP_ID_MAP_TAB = process.env
  .REACT_APP_MAP_TAB_GOOGLE_MAP_ID as string;
const gmapLibrariesToLoad: Library[] = ['geometry', 'marker', 'places'];

export const GoogleMapsApi: FC<{}> = memo(() => {
  const { i18n } = useTranslation();
  const userProfile = useSelector(selectUserProfile);

  const apiKey = useMemo(
    () => userProfile.mapProvider?.browserKey || '',
    [userProfile.mapProvider?.browserKey],
  );

  const { isLoaded, loadError } = useLoadScript({
    id: '__googleMapsScript',
    googleMapsApiKey: apiKey,
    libraries: gmapLibrariesToLoad,
    language: i18n?.language?.split('-')[0],
    mapIds: [GOOGLE_MAP_ID_MAP_TAB],
  });

  useEffect(() => {
    window._MTIGoogleMapsApiLoaded = false;
    window._MTIGoogleMapsApiLoadError = undefined;
  }, []);

  useEffect(() => {
    window._MTIGoogleMapsApiLoaded = isLoaded;
    window._MTIGoogleMapsApiLoadError = loadError;
  }, [isLoaded, loadError]);

  return <></>;
});
